module.exports = __webpack_public_path__ + "media/images/flags/SB-a4dc29aabf40b2124b3248ef4371c755.svg";